const SvgFullMatch = (props) => (
  <svg height="1em" viewBox="0 0 18 15" width="1em" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(0 -2)">
      <path d="M0 0h18v18H0z" />
      <rect
        height={14}
        rx={1}
        stroke="currentColor"
        width={17}
        x={0.5}
        y={2.5}
      />
      <g fill="currentColor">
        <path d="M8.833 12.833V12H13v.833zM5.602 9.917L3 7h1.836l2.14 2.406a.801.801 0 0 1 0 1.036L4.85 12.833H3.013l2.589-2.916z" />
      </g>
    </g>
  </svg>
)

export default SvgFullMatch
